import { render, staticRenderFns } from "./SectionForm.vue?vue&type=template&id=08e81971&scoped=true&"
import script from "./SectionForm.vue?vue&type=script&lang=ts&"
export * from "./SectionForm.vue?vue&type=script&lang=ts&"
import style0 from "./SectionForm.vue?vue&type=style&index=0&id=08e81971&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e81971",
  null
  
)

export default component.exports